<template>
  <v-card>
    <v-card-title>
      Slack
    </v-card-title>
    <v-card-text>
      <v-btn
        v-if="!company.integrationIds.includes($enums.integrations.SLACK)"
        outlined
        :href="href"
      >
        <v-icon class="mr-2">$vuetify.icons.slack</v-icon> Add to Slack
      </v-btn>
      <v-btn outlined v-else @click="removeSlack">
        <v-icon class="mr-2">$vuetify.icons.slack</v-icon> Remove from Slack
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "IntegrationList",
  computed: {
    href() {
      return `https://slack.com/oauth/v2/authorize?client_id=1360121258594.2578824263266&scope=channels:manage,chat:write,groups:read,groups:write,im:read,im:write,mpim:read,mpim:write,users:read,users:read.email,users.profile:read&user_scope=&redirect_uri=${window.location.origin}/slack`;
    },
    ...mapGetters({ company: "company/company" })
  },
  methods: {
    removeSlack() {
      this.$store
        .dispatch("integration/removeSlack")
        .then(() => {
          this.$root.$snackbarSuccess("Slack integration removed");
          this.$store.dispatch("company/getCompany");
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occurred while updating."
          );
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
